module.exports = __webpack_public_path__ + "img/11.ad480644.jpg";